/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { IVariablesNamespace, IVariablesNamespaceRegistry } from '.'
 */

/**
 * @implements {IVariablesNamespaceRegistry}
 */
export default class VariablesNamespaceRegistry {
  constructor() {
    /**
     * @private
     * @type {Map<string, IVariablesNamespace>}
     */
    this.namespaces = new Map();
  }

  /** @type {IVariablesNamespaceRegistry['get']} */
  get(ns) {
    const namespace = this.namespaces.get(ns);
    if (!namespace) {
      throw new Error(`Namespace not found: ${ns}`);
    }
    return namespace;
  }

  /** @type {IVariablesNamespaceRegistry['list']} */
  list() {
    return this.namespaces;
  }

  /** @type {IVariablesNamespaceRegistry['register']} */
  register(ns, namespace) {
    if (this.namespaces.has(ns)) {
      throw new Error(`Namespace already registered: ${ns}`);
    }
    this.namespaces.set(ns, namespace);
  }

  /** @type {IVariablesNamespaceRegistry['unregister']} */
  unregister(ns) {
    this.namespaces.delete(ns);
  }
}
